<panel width="450">
  <h1>{{'leads.header' | translate}}</h1>
  <data-table>
    <data-row>
      <custom-input [label]="'leads.form_zip_label' | translate" [inputType]="inputTypeEnum.Text" [(value)]="zip" [placeholder]="'leads.form_zip_placeholder' | translate" [required]="true" />
    </data-row>
    <data-row>
      <submit-button #leadsSearchButton
        (click)="onSearch()"
        [label]="'leads.form_search' | translate"
        [ignoreValidation]="true">
      </submit-button>
    </data-row>
    @if (leadCompanys.length > 0) {
      <data-row>
        <list-view [emptyLabel]="'leads.leads-list-empty-label'">
          <header defaultSort="ascending">{{ 'leads.column.companyname' | translate }}</header>
          <row *listData="let company from leadCompanys" [highlighted]="selectedLeadCompany == company" (action)="selectLeadCompany(company)">
            <column>{{ company.name }}</column>
          </row>
        </list-view>
      </data-row>
    }
  </data-table>
</panel>
@if (selectedCompany) {
  <leads-single [company]="selectedCompany" [leadCompany]="selectedLeadCompany" />
}
